export type TraceAction = 'blocked' | 'unblocked' | 'deleted';

// The agent the mock stands in for: the same literal the baja's Citibox Helper line already uses.
export const MOCK_AGENT_EMAIL = 'agente@citibox.com';

const pad = (n: number): string => String(n).padStart(2, '0');

// The line backend writes on a courier account when a panel action changes its state. Spelled
// here only so the mock paints what a real environment paints — production code never composes
// it. Always UTC, the format the «Usuario» block already writes.
export function formatTraceLine(action: TraceAction, reason: string, at: Date = new Date()): string {
  const date = `${pad(at.getUTCDate())}/${pad(at.getUTCMonth() + 1)}/${String(at.getUTCFullYear())}`;
  const time = `${pad(at.getUTCHours())}:${pad(at.getUTCMinutes())}`;
  return `${date} ${time} | PANEL-CC:${MOCK_AGENT_EMAIL} | ${action} | ${reason}`;
}

// Appended at the END and on a line of its own: everything already in the observations stays.
export function appendTraceLine(observations: string, line: string): string {
  return observations === '' ? line : `${observations}\n${line}`;
}
